export const SiteNotificationQueryKeys = {
	all: ['site-notification'] as const,
	notifications: (companyHotelId: number) => [...SiteNotificationQueryKeys.all, 'companyHotelId', companyHotelId] as const,
};